import { createStore } from "vuex";
import { organizationApi } from "@/services/backendApi";

export default createStore({
  state: {
    users: [],
    user: null,
    reportToOpenId: null,
    tokenLimit: 25000,
    selectedReports: [],
    reportSelectionMode: "view", // "view" or "select"
  },
  getters: {
    getUserId(state) {
      if (!state.user) {
        return null;
      }
      return state.user.uuid;
    },
    getUserDisplayName(state) {
      if (!state.user) {
        return null;
      }

      if (!state.user.first_name && !state.user.last_name) {
        return state.user.username;
      }

      return state.user.first_name + " " + state.user.last_name;
    },
    getUserOrganization(state) {
      if (!state.user) {
        return null;
      }
      return state.user.organization;
    },
    isUserAdmin(state) {
      if (!state.user) {
        return false;
      }

      const userId = state.user.uuid;
      const organizationAuthorId = state.user.organization.author_id;

      return userId === organizationAuthorId;
    },
    getSelectedReports(state) {
      return state.selectedReports;
    },
    getReportSelectionMode(state) {
      return state.reportSelectionMode;
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    updateUserOrganizationProperty(state, { key, value }) {
      if (!state.user.organization) {
        state.user.organization = {};
      }
      state.user.organization[key] = value;
    },
    updateUserProperty(state, { key, value }) {
      state.user[key] = value;
    },
    setProperty(state, { key, value }) {
      state[key] = value;
    },
    setSelectedReports(state, reports) {
      state.selectedReports = reports;
    },
    addSelectedReport(state, reportId) {
      if (!state.selectedReports.includes(reportId)) {
        state.selectedReports.push(reportId);
      }
    },
    removeSelectedReport(state, reportId) {
      state.selectedReports = state.selectedReports.filter(
        (id) => id !== reportId
      );
    },
    clearSelectedReports(state) {
      state.selectedReports = [];
    },
    setReportSelectionMode(state, mode) {
      state.reportSelectionMode = mode;
    },
  },
  actions: {
    async getOrganizationUsers({ commit }) {
      const response = await organizationApi.users();
      if (!response.success) return;

      commit("setProperty", { key: "users", value: response.payload.items });
    },
  },
});
